<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">포장상품 신청 등록</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span>포장상품명</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.wrapperNm">
                  </td>
                </tr>
                <tr>
                  <th><span>상품이미지</span></th>
                  <td>
                    <div class="form_inline">
                        <button class="btn btn_md btn_blue" @click="fn_wrapperFileUpload">파일업로드</button>
                        <input type="file" ref="wrapperFile" @change="fn_fileWrapperChange" hidden>
                        <ul class="file_list" v-if="regData.wrapperFileNm != ''">
                            <li>{{regData.wrapperFileNm}}</li>
                        </ul>
                    </div>
                  </td>
                </tr>          
                <tr>
                  <th><span>포장종류</span></th>
                  <td>
                    <div class="form_select">
                      <b-form-select v-model="regData.wrapperClass">
                        <b-form-select-option :value="null">선택</b-form-select-option>
                        <b-form-select-option v-for="(item, index) in wrapperClassList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                      </b-form-select>
                    </div>              
                  </td>
                </tr>                       
                <tr>
                  <th><span>판매단가</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.wrapperSalePrc">
                  </td>
                </tr>                               
                <tr>
                  <th><span>기준 재고량</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.wrapperStdrInvtQy">
                  </td>
                </tr> 
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
              <div class="btn_box">
                <!-- <button class="btn btn_md btn_gray">취소</button> -->
                <button class="btn btn_md btn_darkblue" @click="fn_wrapper_reg">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <alert-modal 
            :id="'alert'"
            :text="showAlertMsg" 
            :btnRight="'확인'" 
            :oneBtn="false"
            :isShow="showAlert"
            :className="'btn_brown'"
            v-on:update:showSetting="fn_showSet"
        />
    </div>
</template>

<script>
    import axios from 'axios'
    import AlertModal from "@/modal/common/alertModal.vue"
    import commonUtil from "@/mixin/commonUtil";
    import alertutill from "@/mixin/alertModalUtill";

    export default {
    name: 'WrapperMngtReg',
    mixins: [alertutill,commonUtil],
    components: {
        'alert-modal' : AlertModal,
        //'confirm-modal': AlertModal,
    },
    data() {
        return {
            selected: null,
            regData : {
                wrapperCd : "",
                wrapperNm : "",
                wrapperClass : null,                    
                wrapperSalePrc : "",
                wrapperStdrInvtQy : "",
                wrapperFileid : "",
                wrapperFileNm : "",
                status : ''
            },
            upLoadFile : {
                upFile : ''
            },
            wrapperClassList : []
        }
    },
    async created(){
        //공통코드 - 포장지종류 가져오기
        this.wrapperClassList = await this.getCode('GC00000005');         
        console.log("@@@@ wrapperClassList : %o",this.wrapperClassList);

        this.regData.status = this.$store.getters['wrapper/getStatus'];

        if(this.regData.status == 'M'){
          this.regData.wrapperCd = this.$store.getters['wrapper/getWrapperCd'];  
          this.fn_search(); 
        }


        //this.fn_search();
    },
    methods : {
        fn_move_page(){
            this.$router.push("/admin/wrapper/WrapperMngt");
        },
        fn_wrapperFileUpload(){
            let fileInputElement = this.$refs.wrapperFile;
            fileInputElement.click();
        },
        fn_fileWrapperChange(e){
            this.upLoadFile.upFile = e.target.files[0];
            this.regData.wrapperFileNm = this.upLoadFile.upFile.name;
        },
        async fn_wrapper_reg(){

            console.log("@@@@ this.regData : %o",this.regData);

            var frm = new FormData();

            frm.append("file",this.upLoadFile.upFile);
            frm.append("key",JSON.stringify(this.regData));

            axios
                .post("/api/admin/wrapper/regWrapper", frm, {
                        "Content-Type": "multipart/form-data",
                        "Accept-Language" : "ko"})
                .then((res) => {                            
                    console.log("@@@@ res : %o",res);

                    if(res.data.result == "ok"){
                        // let msg = "저장되었습니다";
                        // this.fn_open_alert(msg);
                        alert("저장되었습니다.");
                        this.fn_move_page();  
                    }else{
                        let msg = res.data.errorMsg;
                        this.fn_open_alert(msg);
                    }                                              
                })
                .catch((err) => console.log(err));


        },
        fn_search(){

          let param = new Object();
          param.wrapperCd = this.regData.wrapperCd;

          console.log("@@@@ param : %o",param);

          axios
              .post("/api/admin/wrapper/wrapperDetail", param)
              .then((res) => {
                  console.log("@@@@ dtl res : %o",res);
                
                  this.regData.wrapperNm = res.data.wrapper_nm;
                  this.regData.wrapperClass = res.data.wrapper_class;
                  this.regData.wrapperFileid = res.data.wrapper_file_id;
                  this.regData.wrapperFileNm = res.data.file_org_name;
                  this.regData.wrapperSalePrc = res.data.wrapper_sale_prc;
                  this.regData.wrapperStdrInvtQy = res.data.wrapper_stdr_invt_qy;
                  
              })
              .catch((err) => console.log(err));
                
        },
    }
  }
</script>